<div class="view-container">
<div class="waybill-review-order-component">
  <mat-card class="ui-wrapper">
    <mat-card-title>Waybill : {{ waybillNumber }}</mat-card-title>

    <div class="details">
      <div class="mbp-table-wrap"><table mat-table [dataSource]="waybillData" class="mbp-data-table mat-elevation-z8">
        <!-- Order Number Column -->
        <ng-container matColumnDef="order_number">
          <th mat-header-cell *matHeaderCellDef>Order Number</th>
          <td mat-cell *matCellDef="let element">{{ element.order_number }}</td>
        </ng-container>

        <!-- Customer Order Number Column -->
        <ng-container matColumnDef="customer_order_number">
          <th mat-header-cell *matHeaderCellDef>Customer Order Number</th>
          <td mat-cell *matCellDef="let element">
            {{ element.customer_order_number || "N/A" }}
          </td>
        </ng-container>

        <!-- Company Name Column -->
        <ng-container matColumnDef="company_name">
          <th mat-header-cell *matHeaderCellDef>Company Name</th>
          <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let element">{{ element.product }}</td>
        </ng-container>

        <!-- Total Quantity Column -->
        <ng-container matColumnDef="total_quantity">
          <th mat-header-cell *matHeaderCellDef>Total Quantity</th>
          <td mat-cell *matCellDef="let element">
            {{ element.total_quantity }}
          </td>
        </ng-container>

        <!-- Date Shipped Column -->
        <ng-container matColumnDef="date_shipped">
          <th mat-header-cell *matHeaderCellDef>Date Shipped</th>
          <td mat-cell *matCellDef="let element">{{ element.date_shipped }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table></div>
    </div>
  </mat-card>
</div>
</div>
